import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import './MachineAppComponentWrapper.css';

export const MachineAppComponentWrapper = (itemComponent: React.ReactElement[]) => {
  const container = $('<div>').addClass('machineapp_component_container');

  ReactDOM.render(itemComponent, container.get(0) as Element);

  container.on('remove', () => {
    ReactDOM.unmountComponentAtNode(container.get(0) as Element);
  });

  return container;
};
